import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: "flex",
    justifyContent: "left",
    gap: theme.spacing(5),
    flexWrap: "wrap",
  },
  card: {
    minWidth: "161px",
    height: "56px",
    alignContent: "center",
    borderRadius: "10px",
    marginTop: "10px",
    textAlign: "center",
    boxShadow: "none",
  },
  cardLabel: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "16px",
    color: theme.custom.color.blackRussian,
    margin: "4px 0",
  },
  cardText: {
    fontWeight: "bold",
  },
  cardVariant: {
    "&.apple": {
      border: `2px solid ${theme.custom.color.apple}`,
    },
    "&.gold": {
      border: `2px solid ${theme.custom.color.gold}`,
    },
    "&.silver": {
      border: `2px solid ${theme.custom.color.silver}`,
    },
  },
}));

export default useStyles;
